import '@angular/compiler';
import { PageAccessComponent } from './page.access/page.access.component';
import { LayoutSidebarComponent } from './layout.sidebar/layout.sidebar.component';
import { PageMypageComponent } from './page.mypage/page.mypage.component';
import { PageReceptionComponent } from './page.reception/page.reception.component';
import { PortalPostDetailComponent } from './portal.post.detail/portal.post.detail.component';
import { PageAdminDiagnosisComponent } from './page.admin.diagnosis/page.admin.diagnosis.component';
import { PageAdminPromptComponent } from './page.admin.prompt/page.admin.prompt.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PagePostsItemComponent } from './page.posts.item/page.posts.item.component';
import { PageDashboardComponent } from './page.dashboard/page.dashboard.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PageAdminHerbsComponent } from './page.admin.herbs/page.admin.herbs.component';
import { PagePostsComponent } from './page.posts/page.posts.component';
import { PagePrescriptionsComponent } from './page.prescriptions/page.prescriptions.component';
import { PageAdminUsersComponent } from './page.admin.users/page.admin.users.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PageChartComponent } from './page.chart/page.chart.component';
import { ComponentNavSidebarComponent } from './component.nav.sidebar/component.nav.sidebar.component';
import { PagePatientsComponent } from './page.patients/page.patients.component';
import { PageScenarioComponent } from './page.scenario/page.scenario.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PageIntakeComponent } from './page.intake/page.intake.component';
import { PageAdminSettingsComponent } from './page.admin.settings/page.admin.settings.component';
import { PageMembersComponent } from './page.members/page.members.component';
import { PageAdminAcupointsComponent } from './page.admin.acupoints/page.admin.acupoints.component';
import { PortalPostListComponent } from './portal.post.list/portal.post.list.component';

const INDEX_PAGE = "dashboard";

import { URLPattern } from "urlpattern-polyfill";
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

let app_routes: Routes = [
    {
        component: LayoutEmptyComponent,
        "children": [
            {
                "path": "access",
                component: PageAccessComponent,
                "app_id": "page.access"
            },
            {
                "path": "intake/:accessKey?",
                component: PageIntakeComponent,
                "app_id": "page.intake"
            }
        ]
    },
    {
        component: LayoutSidebarComponent,
        "children": [
            {
                "path": "mypage",
                component: PageMypageComponent,
                "app_id": "page.mypage"
            },
            {
                "path": "reception",
                component: PageReceptionComponent,
                "app_id": "page.reception"
            },
            {
                "path": "admin/diagnosis",
                component: PageAdminDiagnosisComponent,
                "app_id": "page.admin.diagnosis"
            },
            {
                "path": "admin/prompt",
                component: PageAdminPromptComponent,
                "app_id": "page.admin.prompt"
            },
            {
                "path": "posts/:id/:tab?",
                component: PagePostsItemComponent,
                "app_id": "page.posts.item"
            },
            {
                "path": "dashboard",
                component: PageDashboardComponent,
                "app_id": "page.dashboard"
            },
            {
                "path": "admin/herbs",
                component: PageAdminHerbsComponent,
                "app_id": "page.admin.herbs"
            },
            {
                "path": "posts",
                component: PagePostsComponent,
                "app_id": "page.posts"
            },
            {
                "path": "prescriptions",
                component: PagePrescriptionsComponent,
                "app_id": "page.prescriptions"
            },
            {
                "path": "admin/users",
                component: PageAdminUsersComponent,
                "app_id": "page.admin.users"
            },
            {
                "path": "chart/:visitId?",
                component: PageChartComponent,
                "app_id": "page.chart"
            },
            {
                "path": "patients",
                component: PagePatientsComponent,
                "app_id": "page.patients"
            },
            {
                "path": "scenario",
                component: PageScenarioComponent,
                "app_id": "page.scenario"
            },
            {
                "path": "admin/settings",
                component: PageAdminSettingsComponent,
                "app_id": "page.admin.settings"
            },
            {
                "path": "members",
                component: PageMembersComponent,
                "app_id": "page.members"
            },
            {
                "path": "admin/acupoints",
                component: PageAdminAcupointsComponent,
                "app_id": "page.admin.acupoints"
            }
        ]
    }
];

export class RouteInfo {
    public path: any = "";
    public segment: any = {};

    constructor() { }
}

window.WizRoute = new RouteInfo();

let patternMatcher = (pattern: any, url: any) => {
    let urlpath = url.map((x: any) => x.path).join("/");
    let testurl = 'http://test/';
    pattern = '/' + pattern;
    urlpath = testurl + urlpath;
    pattern = new URLPattern({ pathname: pattern });
    pattern = pattern.exec(urlpath)
    if (pattern && pattern.pathname) {
        let posParams = {};
        for (let key in pattern.pathname.groups) {
            if (pattern.pathname.groups[key]) {
                posParams[key] = pattern.pathname.groups[key];
            }
        }
        window.WizRoute.path = url.map((x: any) => x.path).join("/");
        window.WizRoute.segment = posParams;

        return { consumed: url, posParams: posParams };
    }
    return null
}

let routes: Routes = [{
    matcher: (url: any) => {
        for (let i = 0; i < app_routes.length; i++) {
            let layout = app_routes[i];
            let layout_childs = layout.children;
            for (let j = 0; j < layout_childs.length; j++) {
                let child = layout_childs[j];
                let matcher = patternMatcher(child.path, url);
                if (matcher)
                    return null;
            }
        }
        return { consumed: url, posParams: {} };
    },
    redirectTo: INDEX_PAGE
}];

for (let i = 0; i < app_routes.length; i++) {
    let layout = app_routes[i];
    let layout_component = layout.component;
    let layout_childs = layout.children;

    let router: any = {
        path: '',
        component: layout_component,
        children: []
    };

    for (let j = 0; j < layout_childs.length; j++) {
        let child = layout_childs[j];
        router.children.push({
            matcher: (url: any) => {
                let matcher = patternMatcher(child.path, url);
                if (matcher) return matcher;
                return null;
            },
            component: child.component
        });
    }
    routes.push(router);
}

@NgModule({ imports: [RouterModule.forRoot(routes)], exports: [RouterModule] })
export class AppRoutingModule { }